export default __webpack_public_path__ + "static/media/l-3.f3fe9e69.jpg";